import { Stack, Typography } from '@mui/material';
import AppTheme from '@libs/mui/AppTheme';

type ColorKey = 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info';

const VisitDetailPriceColumn = (props: { paidPrice: string; label: string; color: ColorKey }) => {
  const { paidPrice, label, color } = props;
  return (
    <Stack direction="column" spacing={1}>
      <Typography
        variant="body2"
        fontSize="12px"
        sx={{
          paddingX: 1.5,
          backgroundColor: AppTheme.palette[color].light,
          color: AppTheme.palette[color].main,
          borderRadius: '8px',
          textAlign: 'center',
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        fontSize="13px"
        color="text.primary"
        sx={{ textAlign: 'center' }}
        fontWeight="bold"
      >
        {paidPrice}
      </Typography>
    </Stack>
  );
};

export default VisitDetailPriceColumn;
